export enum VerificationCodeGenerationErrorCodes {
  INVALID_INPUT = 'InvalidInput',
  CODE_GENERATION_LIMIT_REACHED = 'CodeGenerationLimitReached',
  REQUESTED_CODE_VERIFICATION_RESULT_NOT_FOUND_FOR_PUBLISHER = 'RequestedCodeVerificationResultNotFoundForPublisher',
}
